import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {IdentifierConstants, SaldoPermissionConstants} from '../../../app.constants';
import {TableColumn} from '../../../modules/common/models/table.column.model';
import {FieldOfActivityClassifierService} from '../../../services/field-of-activity-classifier.service';
import {FieldOfActivityClassifierTree} from '../../../models/field-of-activity-classifier-tree';
import {ToastrService} from 'ngx-toastr';
import {TranslateService} from '@ngx-translate/core';
import {UserInfoService} from '../../../services/userinfo.service';
import {ArrayUtils} from '../../../utils/ArrayUtils';
import {DownloadSetup} from '../../../utils/DownloadSetup';
import {MediaTypeConstant} from '../../../models/media-type-constant';

@Component({
  selector: 'saldo-field-of-activity-view',
  encapsulation: ViewEncapsulation.None,
  templateUrl: './field-of-activity.component.html',
  styleUrls: ['./field-of-activity.component.scss']
})
export class FieldOfActivityComponent implements OnInit {
  mapIdentifier: string = IdentifierConstants.FIELD_OF_ACTIVITY_CLASSIFIER_VIEW_TABLE_MAP;
  shouldKeepStateIdentifier: string = IdentifierConstants.FIELD_OF_ACTIVITY_CLASSIFIER_SHOULD_KEEP_STATE;

  isAdministrator = false;

  list: FieldOfActivityClassifierTree[];
  columns: TableColumn[];
  loaded = false;
  dwnLoaded = true;


  constructor(private router: Router,
              private route: ActivatedRoute,
              private fieldOfActivityClassifierService: FieldOfActivityClassifierService,
              private userInfoService: UserInfoService,
              private toastr: ToastrService,
              private translate: TranslateService) {
  }

  ngOnInit() {
    const userInfo = JSON.parse(sessionStorage.getItem('userinfo'));
    if (userInfo) {
      this.isAdministrator = this.userInfoService.hasRoleWithUserInfo(SaldoPermissionConstants.ADMINISTRATOR, userInfo);
    }
    this.columns = this.getColumns();
    this.refreshTable();
  }

  goToEditPage(id) {
    this.router.navigate(['muuda/' + id], {queryParams: {id}, relativeTo: this.route});
  }

  goToNewAccountClassifier(code) {
    if (code) {
      this.router.navigate(['uus'], {queryParams: {code}, relativeTo: this.route});
    } else {
      this.router.navigate(['uus'], {relativeTo: this.route});
    }
  }

  deleteItem(id) {
    this.fieldOfActivityClassifierService.removeFieldOfActivityClassifier(id).subscribe(() => {
      ArrayUtils.removeRow(this.list, id);
      this.toastr.success('Tegevusala eemaldatud.', 'Teade', {
        positionClass: 'toast-top-right', closeButton: true, tapToDismiss: false
      });
    }, error => {
      this.toastr.error(this.translate.instant(error), 'Teade', {
        positionClass: 'toast-top-right', closeButton: true, tapToDismiss: false
      });
    });
  }

  refreshTable() {
    this.fieldOfActivityClassifierService.getFieldOfActivityClassifiers().subscribe(res => {
      this.list = res.child;
      this.loaded = true;
    });
  }

  getColumns(): TableColumn[] {
    return [
      {
        name: 'title',
        label: 'Nimetus',
      },
      {
        name: 'code',
        label: 'Kood'
      },
      {
        name: 'validTo',
        label: 'Kehtiv kuni',
      }];
  }

  saveAsExcel() {
    this.dwnLoaded = false;
    this.fieldOfActivityClassifierService.downloadExcel().subscribe(response => {
      DownloadSetup.setupDownloadProperties(MediaTypeConstant.EXCEL, response, 'Tegevusalad.xls');
      this.dwnLoaded = true;
    }, () => {
      this.dwnLoaded = true;
    });
  }

  saveAsXml() {
    this.dwnLoaded = false;
    this.fieldOfActivityClassifierService.downloadXml().subscribe(response => {
      DownloadSetup.setupDownloadProperties(MediaTypeConstant.XML, response, 'Tegevusalad.xml');
      this.dwnLoaded = true;
    }, () => {
      this.dwnLoaded = true;
    });
  }

  hasAdministratorRole() {
    return this.isAdministrator;
  }
}
